import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HalResource, HalResourceService, INIT_BY_JSON_2_TS} from '@drklein-pk/tng-angular-common';
import {Observable} from 'rxjs';
import {JsonObject, JsonProperty} from 'json2typescript';
import {LeadType} from './lead.type';

@JsonObject('LeadSourceResource')
export class LeadSourceResource extends HalResource {
  @JsonProperty('id', String)
  id: string = INIT_BY_JSON_2_TS;

  @JsonProperty('name', String)
  name: string = INIT_BY_JSON_2_TS;

  @JsonProperty('leadType', String)
  leadType: LeadType = INIT_BY_JSON_2_TS;

  get leadProvider(): LeadProviderResource | undefined {
    return this.getEmbedded('leadProvider', LeadProviderResource);
  }
}

@JsonObject('LeadProviderResource')
export class LeadProviderResource extends HalResource {
  @JsonProperty('id', String)
  id: string = INIT_BY_JSON_2_TS;

  @JsonProperty('name', String)
  name: string = INIT_BY_JSON_2_TS;

  @JsonProperty('status', String)
  status: 'ACTIVE' = INIT_BY_JSON_2_TS;
}

type NewLeadResource = Record<string, string>;

@Injectable()
export class LeadSourceService extends HalResourceService<LeadSourceResource> {
  constructor(httpClient: HttpClient) {
    super('leadSources', httpClient, LeadSourceResource, '/api/leadsourceservice/v1');
  }

  getLeadSources(): Observable<LeadSourceResource[]> {
    return this.findAllPages(`lead-sources`, {size: 2000});
  }

  createLead(leadSourceId: string, newLeadResource: NewLeadResource): Observable<any> {
    const formData = new FormData();
    Object.keys(newLeadResource).forEach((key) => {
      formData.append(key, newLeadResource[key]);
    });
    return this.http.post(
      `${this.baseUrl}/lead-sources/${leadSourceId}/leads`,
      formData,
    );
  }
}
